import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_4_11b
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
    selector: 'app-visit-exemptions-exemption-4-11b',
    templateUrl: './exemption_4_11b.component.html',
    styleUrls: ['./exemption_4_11b.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_4_11bComponent extends ExemptionBaseComponent {

  @Input() exemption: Exemption_4_11b;

  dangerousGoods?: DangerInformation
  portVisitUtils = PortvisitUtils;
}

